import { LinkButton, TooltipDesktop } from '@cian/ui-kit';
import { IconFileDoc16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { trackDownloadOfferDoc } from './tracking';
import { useOfferContext } from '../../../../context';
import { ControlWrapper } from 'shared/components/Controls/ControlWrapper';

interface IProps {
  isHovered: boolean;
}

export const DownloadDOCControlContainer = ({ isHovered }: IProps) => {
  const { offer, position } = useOfferContext();

  const { fullUrl, id } = offer;

  const url = React.useMemo(() => (fullUrl ? fullUrl.replace('.ru/', '.ru/export/docx/') : ''), [fullUrl]);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
    trackDownloadOfferDoc(id ?? undefined, position);
  };

  if (!url) {
    return null;
  }

  return (
    <ControlWrapper visible={isHovered}>
      <TooltipDesktop theme="black" placement="left" title="Скачать DOC">
        <LinkButton
          data-mark="DownloadDOCControl"
          target="_blank"
          size="XS"
          theme="stroke_secondary"
          onClick={handleClick}
          href={url}
          beforeIcon={<IconFileDoc16 />}
        />
      </TooltipDesktop>
    </ControlWrapper>
  );
};
